export const NetScanEnum = [
  { "key": "Class C/24", "value": 0 },
  { "key": "Class C/20", "value": 1},
  { "key": "Class B/16", "value": 2},
  { "key": "Custom", "value": 3 }
]



// WEBPACK FOOTER //
// ./src/components/subtestsetting/netscan/netscanenum.js